import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

const ListaPage = React.lazy(() => import('./lista'))
const NuevaPage = React.lazy(() => import('./nueva'))

export default function ProvisionesPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CodigosTransaccionesConstant.PROVISIONES_NUEVA}`} component={NuevaPage} />
        <Route path={`/${CodigosTransaccionesConstant.PROVISIONES_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
